module.exports = __webpack_public_path__ + "static/media/picker2.a9c0b49a.svg";